module.exports = __webpack_public_path__ + "static/media/celebrate_selected.ba7312de.svg";